import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RComponentClassGroup } from './r-component-class-group.action';

interface RComponentClassGroupXsStateModel {
  createComponentClassGroup: string;
  editComponentClassGroup: string;
  deleteComponentClassGroup: string;
}

const getDefaults = (): RComponentClassGroupXsStateModel => ({
  createComponentClassGroup: null,
  editComponentClassGroup: null,
  deleteComponentClassGroup: null,
});

@State<RComponentClassGroupXsStateModel>({
  name: 'rComponentClassGroup',
  defaults: getDefaults()
})
@Injectable()
export class RComponentClassGroupXsState {

  //region SELECTOR
  @Selector()
  static canCreateComponentClassGroup(state: RComponentClassGroupXsStateModel): boolean {
    return state.createComponentClassGroup != null;
  }

  @Selector()
  static canEditComponentClassGroup(state: RComponentClassGroupXsStateModel): boolean {
    return state.editComponentClassGroup != null;
  }

  @Selector()
  static canDeleteComponentClassGroup(state: RComponentClassGroupXsStateModel): boolean {
    return state.deleteComponentClassGroup != null;
  }
  //endregion

  //region ACTIONS
  @Action(RComponentClassGroup.SetComponentClassGroupPrivileges)
  public setComponentClassGroupPrivileges(
    ctx: StateContext<RComponentClassGroupXsStateModel>,
    action: RComponentClassGroup.SetComponentClassGroupPrivileges
  ) {
    const state = ctx.getState();
    const componentClassGroupPrivileges: string[] = action.activeUserRightInfoDtoModel.componentClassGroupPrivileges
      ? [...action.activeUserRightInfoDtoModel.componentClassGroupPrivileges]
      : [];

    //find user privilege data model
    const createComponentClassGroup: string =
      componentClassGroupPrivileges.find(id => id === UserPrivilegeEnum.CREATE_COMPONENT_CLASS_GROUP);
    const editComponentClassGroup: string =
      componentClassGroupPrivileges.find(id => id === UserPrivilegeEnum.EDIT_COMPONENT_CLASS_GROUP);
    const deleteComponentClassGroup: string =
      componentClassGroupPrivileges.find(id => id === UserPrivilegeEnum.DELETE_COMPONENT_CLASS_GROUP);

    //set the state
    ctx.setState({
      ...state,
      createComponentClassGroup,
      editComponentClassGroup,
      deleteComponentClassGroup
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RComponentClassGroupXsStateModel>): void {
    ctx.setState({ ...getDefaults() });
  }
  //endregion

}
